module.exports = __webpack_public_path__ + "static/media/cityFarms.4498f91b.jpg";